import Iconify from 'src/components/iconify';
import { TodoList } from 'src/requests/todos';

export const TodoListAvatar = ({
  todo,
}: {
  todo: Pick<TodoList, 'name' | 'icon'>;
}) => {
  if (todo.icon) return <em-emoji shortcodes={todo?.icon} />;

  return <Iconify icon="icon-park-outline:check-one" />;
};
